
import { Form } from 'element-ui';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'roomConfirm',
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private selectedRoom!: any;

  private type = this.selectedRoom.checked ? 1 : 2;

  private loading = false;

  private skipConfirm = false;

  private submitForm() {
    this.$confirm('해당 설정을 저장하시겠습니까?', '설정 저장', {
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      type: 'warning',
    }).then(() => {
      this.loading = true;
      // saveComplete(this.form).then(() => {
      // this.$message({
      // type: 'success',
      // message: '설정을 저장했습니다.',
      // });
      this.$emit('submit');
      // }).catch(() => {
      this.loading = false;
      // });
    });
  }

  private handleClose() {
    this.$emit('close');
  }
}
